/** Карточка лида — ровно то, что отдаёт `GET /api/leads/{id}/card`.
 * Лид со сделкой: только `deals` и `redirect`, ленты нет. */
import { apiFetch } from "@/lib/api";
import type { CardEvent, DealCard } from "@/lib/dealCard";

export type LeadField = { code: string; label: string; value: string; main: boolean };

export type LeadCard = {
  lead: NonNullable<DealCard["lead"]>;
  deals: number[];
  redirect: number | null;
  deleted?: boolean;
  phones?: string[];
  fields?: LeadField[];
  summary?: DealCard["summary"];
  events?: CardEvent[];
  errors?: string[];
};

export function loadLeadCard(id: number): Promise<LeadCard> {
  return apiFetch<LeadCard>(`/api/leads/${id}/card`);
}
